import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { DeskLink } from '@/components/generals/desk-link'
import { AboutDesk } from '@/components/about/about-desk'

const About: FC = (): ReactNode => {
    return (
        <>
            <Seo
                title='About'
                description='Maren Okonkwo, photographer, Lisbon. Twelve years, five looks, one desk — how a job runs, what each look is made of, and the frames worth keeping.'
                ogImage='https://pub-dc2abe5caae44240a6d1913566a75e0f.r2.dev/sections/cutout/cinematic-05.jpg'
            />

            <main className='relative'>
                <AboutDesk />

                <DeskLink href='/'>← back to the mat</DeskLink>
            </main>
        </>
    )
}

export default About
